module.exports = __webpack_public_path__ + "static/media/trial1-after-10-sek-if-wrong.3f29957c.mp3";